import { createFileRoute, redirect } from '@tanstack/react-router';

// Deprecated deep-link redirect: the Robots feature became Notifications (the
// event-triggered action type). `/automations/robots` permanently redirects to
// `/notifications` so existing bookmarks and links keep working.
export const Route = createFileRoute('/_auth/_side-layout/automations_/robots')({
  beforeLoad: () => {
    throw redirect({ to: '/triggers' });
  },
});
